import * as yup from 'yup'

export const addDisciplineSchema = yup.object({
	name: yup.string().required(),
})
